<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
  </div>
</template>

<script>
import router from "@/router";
export default {
  name: "EntityCellRendererActions",
  computed: {
    entity() {
      return this.params.data;
    }
  },
  methods: {
    editRecord() {
      this.entity.open(router);
    },
    confirmDeleteRecord() {
      this.params.context.componentParent.deleteEntity(this.entity);
    }
  }
};
</script>
